import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, PDFDownloadLink } from '@react-pdf/renderer';
import QRCode from "qrcode";
import { Button, Col, Row } from 'reactstrap';
import axios from 'axios';
import logoPath from "./../../assets/hptilogo.jpg";
import hkclLogo from "./../../assets/image.png";
import imageCompression from 'browser-image-compression';


import BASE_URL, { fetchAdmitCardDetails, saveAdmitDownloadHistory } from '../Services/Employees';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  header: {
    fontSize: 16,
    marginBottom: 10,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },

  headers: {
    fontSize: 12,
    marginBottom: 10,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  instruction: {
    fontSize: 11,
    marginBottom: 9,
  },
  signatureBox: {
    border: '1px solid black',
    padding: 2,
    fontSize: 10,
  },
  qrCode: {
    width: 100,
    height: 100,
  },
  logoPath: {
    width: 50,
    height: 50,
  },

  boldText: {
    fontSize: 20,
  },
  headerText: {
    textAlign: 'center',
    fontSize: 11,
    //textDecoration: 'underline',
    fontWeight: 'bold',
  },
  text_id: {
    fontSize: 14,
  },
  inst: {
    fontSize: 10,
    marginBottom: 6,
    wordWrap: 'break-word',

  },


  colorBox: {
    width: 20,
    height: 20,
    marginRight: 10,
    borderWidth: 1,
    borderColor: '#000',
  },
  hkcl: {
    fontSize: 12,

  }

});

const AdmitCard = () => {
  const [downloadMessage, setDownloadMessage] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);
  const [admitCardStatus, setAdmitCardStatus] = useState(null);
  const [examDetails, setExamDetails] = useState({});
  const [img, setImg] = useState('');
  const [activeEvent, setActiveEvent] = useState('');
  const [examDate, setExamDate] = useState('');
  const imageUrl = BASE_URL + "/fetchImage";


  const compressImage = async (base64Image) => {
    const response = await fetch(base64Image);
    const blob = await response.blob();


    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };


    const compressedBlob = await imageCompression(blob, options);


    const compressedBase64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(compressedBlob);
      reader.onloadend = () => resolve(reader.result);
    });

    return compressedBase64;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchAdmitCardDetails();

        if (response.status === 200) {
          setAdmitCardStatus(200);

          // Compress image
          const base64Image = 'data:image/jpeg;base64,' + response.data.data.image;
          const compressedImageBase64 = await compressImage(base64Image);

          // Update state with compressed image and other data
          setImg(compressedImageBase64);
          setActiveEvent(response.data.data.event);
          setExamDate(response.data.data.examDate || '');
          setExamDetails(response.data.data);
        } else {
          setAdmitCardStatus(404);
          const waitingData = response.data?.data;
          if (waitingData && typeof waitingData === 'object') {
            setActiveEvent(waitingData.event || '');
            setExamDate(waitingData.examDate || '');
          } else if (typeof waitingData === 'string') {
            setActiveEvent(waitingData);
          }
        }
      } catch (error) {
        setAdmitCardStatus(404);
        const waitingData = error.response?.data?.data;
        if (waitingData && typeof waitingData === 'object') {
          setActiveEvent(waitingData.event || '');
          setExamDate(waitingData.examDate || '');
        } else if (typeof waitingData === 'string') {
          setActiveEvent(waitingData);
        }
      }
    };

    fetchData();
  }, []);

  const generatePDF = () => (
    <Document>
      <AdmitCardFirstPage examDetails={examDetails} img={img} />
      <InstructionPages />
    </Document>
  );


  const fetchImage = async () => {
    const res = await fetch(imageUrl, { headers: { "Authorization": localStorage.getItem("tokenId") } });
    const imageBlob = await res.blob();
    console.log(res)
    console.log(imageBlob)
    const imageObjectURL = URL.createObjectURL(imageBlob);
    setImg(imageObjectURL);
  };
  const handleDownload = () => {
    const data = { eventName: activeEvent };

    saveAdmitDownloadHistory(data).then((response => {

    }))
    setDownloadMessage('Your PDF download has started.');
    setTimeout(() => {
      setShowThankYou(true);
      setTimeout(() => {
        setDownloadMessage('');
      }, 1000);
    }, 2000);
  };

  return (

    <div className="card border-0" style={{ background: "white" }}>
      <div style={{ minHeight: "245px" }}>
        {admitCardStatus === 200 ? (
          <h5 className='text-center' style={{ marginTop: "7%", color: '#151e6bdb' }}>
            Dear Candidate, Kindly download your admit card for exam event: <strong>{activeEvent}</strong>
            {examDate ? <> . Exam Date: <strong>{examDate}</strong></> : null}
          </h5>
        ) : (

          <p style={{ textAlign: 'center', marginTop: '7%', color: '#151e6bdb' }}>
            <h4> Event Details <strong>{activeEvent}</strong></h4>
            {examDate ? <h4>Exam Date: <strong>{examDate}</strong></h4> : null}
            <h4>Dear Candidate, Please  Wait for admit card to be published.</h4>
          </p>
        )}

        {admitCardStatus === 200 && (
          <PDFDownloadLink document={generatePDF()} fileName="AdmitCard.pdf" onClick={handleDownload}>
            {({ loading }) => (
              <div className='text-center'>
                <Button style={{ width: "30%", marginTop: "7%", backgroundColor: '#b63d3de0' }}>
                  {loading ? 'Loading document...' : 'Download PDF'}
                </Button>
              </div>
            )}
          </PDFDownloadLink>
        )}

        {downloadMessage && (
          <div style={{ textAlign: 'center', color: 'green' }}>
            <strong>{downloadMessage}</strong>
          </div>
        )}

        {showThankYou && (
          <p style={{ textAlign: 'center', marginTop: '10px', color: '#151e6bdb' }}>
            Thank you for downloading your admit card.
          </p>
        )}
      </div>
    </div>

  );
};

const AdmitCardFirstPage = ({ examDetails, img }) => {
  const [qrCodeDataURL, setQRCodeDataURL] = useState(null);

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        const { hrmsId, employeeName, fatherName, designation, placeOfposting } = examDetails;
        const padData = (data, width) => data + ' '.repeat(width - data.length);
        const currentDateTime = new Intl.DateTimeFormat(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', weekday: "long", hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).format(new Date());
        const formattedText = `
          HRMS ID:  ${padData(hrmsId)}
          Candidate Name:  ${padData(employeeName)}
          Father's Name:  ${padData(fatherName)}
          Post:  ${padData(designation)}
          Present Place of Posting:  ${padData(placeOfposting)}
          Date:${currentDateTime}`;
        const qrCode = await QRCode.toDataURL(formattedText, {
          errorCorrectionLevel: 'L',
          margin: 7,
          color: {
            dark: '#000000',
            light: '#ffffff'

          },
          width: 500
        });
        setQRCodeDataURL(qrCode);
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    };

    generateQRCode();
  }, [examDetails]);




  // const generateQRCodeDataURL = async (text) => {
  //   try {
  //     const dataURL = await QRCode.toDataURL(text);
  //     return dataURL;
  //   } catch (error) {
  //     console.error('Error generating QR code:', error);
  //     return null;
  //   }
  // };



  return (
    <Page size="A4">
      <View style={[styles.section, { marginTop: '2%' }]}>

        <View style={{ flexDirection: 'row' }}>
          <View style={{ justifyContent: 'center', alignItems: 'center', width: "15%", marginRight: "1%" }}>
            <Image src={logoPath} style={styles.logoPath} />
          </View>
          <View style={{ textAlign: 'left', width: "85%", marginTop: 10 }}>

            <Text style={{ fontSize: 11 }} >HVPN Power Training Institute</Text>
            <Text style={{ fontSize: 9 }}>HPTI Complex, Sector 26,</Text>
            <Text style={{ fontSize: 9 }}>Panchkula (Haryana)</Text>
          </View>

          <View style={{ textAlign: 'right', width: "85%", marginRight: "3%", marginLeft: "5%", marginTop: 10 }}>

            <Text style={{ fontSize: 11 }} >Haryana Knowledge Corporation Limited</Text>
            <Text style={{ fontSize: 9 }}>Plot No 1, 4th Floor, South Wing, HSIIDC IT Park, Sector 22,Panchkula (Haryana)</Text>

          </View>
          <View style={{ justifyContent: 'center', alignItems: 'center', width: "9%", marginRight: "1%" }}>
            <Image src={hkclLogo} style={styles.logoPath} />
          </View>

        </View>
        {/* <View style={{ justifyContent: 'center', alignItems: 'center', width: "15%", marginRight: "1%" }}>
            {qrCodeDataURL && <Image src={qrCodeDataURL} style={styles.qrCode} />}
          </View> */}

        <Text></Text>
        <View style={{ marginTop: 20 }}>
          <Text style={styles.headerText}>
            ADMIT CARD FOR COMPUTER KNOWLEDGE TEST AND TYPING TEST FOR
          </Text>
          <Text style={styles.headerText}>
            DIRECTLY RECRUITED EMPLOYEES OF VARIOUS CATEGORIES OF POSTS OF HVPNL
          </Text>
          <View>

            {/* Details on the left */}
            <Row style={{ flexDirection: 'row', marginTop: 10 }}>
              {/* Details box */}
              <Col md={6} style={{ wordWrap: 'break-word', width: "95%" }}>
                <div style={{ padding: '10px', marginRight: '10px' }}>

                  <React.Fragment>

                    <Text style={styles.instruction}>HRMS ID : {examDetails.hrmsId}</Text>
                    <Text style={styles.instruction}>Candidate Name : {examDetails.employeeName}</Text>
                    <Text style={styles.instruction}>Father’s Name : {examDetails.fatherName}</Text>
                    <Text style={styles.instruction}>Post : {examDetails.designation} </Text>
                    <Text style={styles.instruction}>Present Place of Posting : {examDetails.placeOfposting}</Text>
                    {/* <Text style={styles.instruction}>Mobile No :{examDetails.}</Text> */}
                  </React.Fragment>


                </div>
              </Col>


              <Col md={3} className="text-center" style={{ wordWrap: 'break-word', width: "40%" }}>
                {/* First photo box with details */}
                <div style={{ border: '1px solid black', margin: '5px', height: 130, justifyContent: 'center' }}>
                  {/* <Text style={styles.text}>Passport </Text>
                      <Text style={styles.text}>Name: {.name}</Text>
                      <Text style={styles.text}>HRMS ID: {.hrmsId}</Text> */}
                  <Image src={img}></Image>
                </div>
              </Col>
              {/* <Col md={4}><Text style={styles.text}>-</Text></Col> */}
              <Col md={3} className="text-center" style={{ wordWrap: 'break-word', width: "40%" }}>

                <div style={{ border: '1px solid black', margin: '5px', height: 130, justifyContent: 'center' }}>
                  {<Text style={{ fontSize: 9, textAlign: 'center' }}>
                    Please affix here your {'\n'} recent passport size color photograph duly signed & stamped by your concerned Gazzeted Controlling Officer (SDO/ Xen/ AO/Sr. A.O. etc.)
                  </Text>}
                </div>
              </Col>
            </Row>








            <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              {/* Left column with exam details */}

              <Col md={8} style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Text style={styles.instruction}>EXAM DETAILS:</Text>
                <Text style={styles.instruction}>Paper Details : {examDetails.course}</Text>
                <Text style={styles.instruction}>Exam Date : {examDetails.examDate}</Text>
                <Text style={styles.instruction}>Reporting Time : {examDetails.reportingTime}</Text>
                <Text style={styles.instruction}>Exam Time : {examDetails.writtenExamTime}</Text>
                <Text style={styles.instruction}>Exam Centre : {examDetails.centre}</Text>
                <Text style={styles.instruction}>Centre Name & Address : {examDetails.centreName} {examDetails.centreAddress}</Text>
                <Text style={styles.instruction}>Google Location Link:
                  <Text style={[styles.instruction, { color: "blue", textDecoration: 'underline' }]}>
                    {examDetails.centerLink}
                  </Text>
                </Text>

              </Col>




              {/* Right column with QR code image */}
              <Col md={3} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', marginRight: '15px' }}>
                {qrCodeDataURL && <Image src={qrCodeDataURL} style={styles.qrCode} />}
              </Col>
            </Row>




            <Row style={{ display: 'flex', flexDirection: 'row', marginTop: '0%' }}>
              {/* Common box style */}
              {[
                'Signature of Candidate',
                'Stamp & Signature of the concerned Gazzeted Controlling Officer (SDO/Xen/AO/Sr.A.O. etc.) of the employee, HVPNL',
                'Stamp & Signature of HKCL Exam Centre Invigilator'
              ].map((text, index) => (
                <Col key={index} md={6} style={{ wordWrap: 'break-word', width: '95%', marginTop: '0' }}>
                  <div style={{
                    border: '1px solid black',
                    padding: '10px',
                    marginRight: '10px',
                    height: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end' // Aligns text to the bottom
                  }}>
                    <Text style={{ fontSize: 10, textAlign: 'center' }}>{text}</Text>
                  </div>
                </Col>
              ))}
            </Row>



          </View>

        </View>
        <Text style={[styles.headers, { marginTop: 10 }]}>IMPORTANT INSTRUCTIONS FOR THE CANDIDATES:</Text>
        <Text style={styles.inst}>
          1.	The candidates must bring their legibly downloaded & printed Admit Cards in original by affixing recent colored photograph at designated place duly signed & stamped by their concerned Gazzeted controlling officer (SDO/Xen/AO/Sr. A.O. etc.) mandatorily along with one ID Proof with photo in original like Departmental ID Card/Aadhar Card/Driving License/Voter Card/ Passport at the Examination Centre failing which candidate will not be allowed to enter in the Examination Centre for the Test.
        </Text>
        <Text style={styles.inst}>
          2.	In case, any type of discrepancy is found by the Invigilator during the checking of the Admit Card for identification & verification of the candidate, he/she shall not be allowed for the Test.
        </Text>
        <Text style={styles.inst}>
          3.	The candidate should reach the examination centre 15 minutes before the start of examination as per schedule, otherwise he/she will not be allowed to enter in the examination centre.
        </Text>



      </View>

    </Page >
  );
};
const currentDateTime = new Intl.DateTimeFormat(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', weekday: "long", hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).format(new Date());
const InstructionPages = () => {
  return (
    <>
      {/* Page 1 */}
      <Page size="A4">
        <View style={[styles.section, { marginTop: '3%' }]}>

          <Text style={styles.inst}>
            4.	The candidates must report at their allocated Exam Center well in time for their timely checking of the admit card by the invigilator, marking of attendance, allocation of Computer System, ensuring its healthiness and to complete other formalities before the starting of the online Test.
          </Text>

          <Text style={styles.inst}>
            5.	The candidates must ensured before the start of the examination about the healthy working of computer system assigned to him. If there is found any technical/network issue, the candidate should immediately inform to the Invigilator to get rectified the same before the start of the examination.
          </Text>
          <Text style={styles.inst}>
            6.	The candidates shall not start the exam until they are asked for the same by the Invigilator.
          </Text>
          <Text style={styles.inst}>
            7.	Each question has four alternative answers of which only one is correct. Each question is allocated 1 (one) mark for each correct response and there is no negative marking for an incorrect response.
          </Text>
          <Text style={styles.inst}>
            8.	Click one of the answer option buttons to select your answer. To change an answer, simply click the desired option button. Click on SAVE & NEXT to save the answer before moving to the next question. The next question will automatically be displayed.
          </Text>
          <Text style={styles.inst}>
            9.	To go to a question, click on the question number in the Question Palette on the right-hand side of the screen.
          </Text>
          <Text style={styles.inst}>
            10. The color-coded diagram on the right side of the screen shows the status of the questions:
          </Text>
          <View style={styles.container}>
            <View style={{ flexDirection: 'row', marginRight: '25%' }}>
              <View style={[styles.colorBox, { backgroundColor: '#ffffff' }]} />
              <Text style={styles.inst}>White - you have not visited question.</Text>
            </View>

            <View style={{ flexDirection: 'row', marginRight: '25%', marginTop: "2" }}>
              <View style={[styles.colorBox, { backgroundColor: '#ff0000' }]} />
              <Text style={styles.inst}>Red - you have not answered the question.</Text>
            </View>

            <View style={{ flexDirection: 'row', marginRight: '25%', marginTop: "2" }}>
              <View style={[styles.colorBox, { backgroundColor: '#00ff00' }]} />
              <Text style={styles.inst}>Green - you have answered the question.</Text>
            </View>
          </View>
          <Text style={styles.inst}>
            11.	Only the answered questions (saved) will be considered for calculating the final score.
          </Text>
          <Text style={styles.inst}>
            12.	Do Not PRESS any keyboard key once the exam is started. This may LOCK your exam. You can inform the exam Invigilator to unlock the same and continue with Exam.
          </Text>
          <Text style={styles.inst}>
            13.	The candidates shall not be allowed to leave & end the Test before its half time. The candidates can end the test with button “End Test” only after elapsing of half time. They shall also not be allowed to go for toilet/washroom etc. during the examination.
          </Text>
          <Text style={styles.inst}>
            14.	The clock has been set at the server and counts down timer at the top right corner of the screen will display the left out time. When the time left becomes 0, then the online Test will be submitted by default, and the candidates shall not be able to make any changes.
          </Text>
          <Text style={styles.inst}>
            15.	If any candidate closes the Exam window without ending the Test, his/her result will not be considered.
          </Text>
          <Text style={styles.inst}>
            16.	The candidates need to complete their exam in the mentioned time only. The extension of time will not be allowed.
          </Text>
          <Text style={styles.inst}>
            17.	If there is a power failure or network problem while a candidate is attempting the exam, the candidate can log in again after the problem is resolved and continue the Exam. The candidates shall be allowed for the remaining time.
          </Text>
          <Text style={styles.inst}>
            18.	The employees appearing for both Computer Knowledge Test (MCQ Based) and Type Test shall remain seated on their seats for their Type Test after the completion of the Computer Knowledge Test (MCQ Based).
          </Text>
          <Text style={styles.inst}>
            19.	The candidates shall not be allowed to carry any Electronic Gadget (mobile phone, smart watch etc.) in the Exam Center. If any candidate is found possessing any such item, he/she will not be allowed for the Test.
          </Text>

          <Text style={styles.inst}>
            20.	The Tests shall be conducted with continuous webcam monitoring & collage capturing. Any candidate attempting any type of cheating/ manipulation during the Tests shall be liable for cancellation of candidature and for strict disciplinary action by their department.
          </Text>
          <Text style={styles.inst}>
            21.	The Admit Cards in original shall have to be deposited by the candidates to the Invigilator at the Exam Centre.
          </Text>

          <Text style={styles.inst}>
            22.	No request of any candidate to change the Date, Time and allocated Exam Center shall be entertained in any circumstances.
          </Text>

          <Text style={styles.inst}>
            23.	The employee candidates are advised to read & follow the instructions carefully. If any employee does not comply with the instructions and creates any kind of interruption & indiscipline during the Exam, he/she will be liable for cancellation of candidature and for strict disciplinary action by their department.
          </Text>

          <View style={{ textAlign: "right", marginTop: '1%' }}>

            <Image
              source={require('./../../assets/signature.png')}
              style={{ width: 70, height: 50, marginLeft: "70%" }}
            />
            <Text style={[styles.hkcl, { marginLeft: "55%", textAlign: "center" }]}>
              Authorised Signatory {'\n'}for Haryana Knowledge Corporation Ltd.
            </Text>
          </View>
          <Text style={[styles.instruction, { marginTop: '3%', bottom: 0, textAlign: "right", marginRight: "10%" }]}> <b>DOWNLOADING DATE AND TIME:</b> {currentDateTime.toLocaleString()}</Text>

        </View>
      </Page>


    </>
  );
};


export default AdmitCard;
